<template>
  <div>
    <b-modal no-fade size="lg" id="modal-user" no-close-on-esc no-close-on-backdrop title="Usuário">
      <b-row>
        <b-col lg="12">
          <b-form-group label="E-mail" label-size="sm" label-for="email">
            <b-form-input
              maxlength="255"
              size="sm"
              id="email"
              v-model="user.email"
              :disabled="action !== 'new'"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-form-group label="Nome" label-size="sm" label-for="name">
            <b-form-input
              size="sm"
              id="name"
              maxlength="255"
              v-model="user.name"
              :disabled="action === 'view'"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-form-group label="Cargo" label-size="sm" label-for="cargo">
            <b-form-input
              size="sm"
              id="cargo"
              maxlength="255"
              v-model="user.cargo"
              :disabled="action === 'view'"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col lg="12">
          <b-form-group label-size="sm" label="Empresa" label-for="cliente_id">
            <v-select
              id="cliente_id"
              :disabled="action === 'view'"
              :options="combos.customers"
              label="razao_social"
              :reduce="customer => customer.cliente_id"
              :clearable="false"
              v-model="user.cliente_id"
            >
              <template #no-options="{}">Sem dados a serem exibidos</template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col lg="2">
          <b-form-group label="Ativo" label-size="sm" label-for="ind_ativo">
            <b-form-checkbox
              id="ind_ativo"
              v-model="user.ind_ativo"
              name="ind_ativo"
              value="1"
              :disabled="action === 'view'"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col lg="4">
          <b-form-group label-size="sm" label="Perfil" label-for="perfil_id">
            <v-select
              id="perfil_id"
              :disabled="action === 'view'"
              :options="[
                    {id: 1, label: 'Administrador'}, 
                    {id: 2, label: 'Diretor de UO'},
                    {id: 3, label: 'Gerente de Departamento'},
                    {id: 4, label: 'Gestor de Contrato'},
                    {id: 5, label: 'Colaborador'},
                    {id: 6, label: 'Cliente'}]"
              label="label"
              :reduce="p => p.id"
              :clearable="false"
              v-model="user.perfil_id"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>

      <template v-slot:modal-footer>
        <b-button v-if="action !== 'view'" size="sm" @click="saveRecord()" variant="primary">
          <i class="fas fa-check"></i> Gravar
        </b-button>
        <b-button size="sm" @click="() => $bvModal.hide('modal-user')">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";

export default {
  name: "ModalUser",
  props: {
    user: { type: Object, required: true },
    action: { type: String, required: true, default: "view" }
  },
  data: function() {
    return {
      combos: {
        customers: []
      }
    };
  },
  methods: {
    validateRecord() {
      let _msg = "";

      if ((this.user.name || "") === "") _msg = "Informe o Nome";

      if ((this.user.email || "") === "")
        _msg += (_msg !== "" ? "<br/>" : "") + "Informe o E-mail!";

      if ((this.user.cargo || "") === "")
        _msg += (_msg !== "" ? "<br/>" : "") + "Informe o Cargo!";

      if (_msg !== "") {
        this.$toasted.info(_msg, {
          duration: 4000,
          keepOnHover: true,
          className: "v-toasted-warning"
        });
        return false;
      }
      return true;
    },
    // loadCombos() {
    //   axios
    //     .get(`${baseApiUrl}/clientes`)
    //     .then(resp => (this.combos.customers = resp.data))
    //     .catch(ex => showError(ex));
    // },
    saveRecord() {
      if (!this.validateRecord()) return;

      if (this.action === "new") {
        let _user = {...this.user}
        _user.password = "123456";
        axios
          .post(`${baseApiUrl}/usuarios`, _user)
          .then(() => {
            this.$bvModal.hide("modal-user");
            this.$emit("updated");
          })
          .catch(err => {
            showError(err);
          });
      } else {
        axios
          .put(`${baseApiUrl}/usuarios/${this.user.email}`, this.user)
          .then(() => {
            this.$bvModal.hide("modal-user");
            this.$emit("updated");
          })
          .catch(err => {
            showError(err);
          });
      }
    }
  },
  mounted() {
    //this.loadCombos();
  }
};
</script>

<style>
</style>